import { RoutingOption } from '~/shared/types/portal'

export type RoutingType = 'browserWithCors' | 'browserWithoutCors' | 'proxy'

export const getRoutingType = (routing: RoutingOption, credentialsEnabled: boolean): RoutingType => {
  if (routing === RoutingOption.BROWSER) {
    return credentialsEnabled ? 'browserWithCors' : 'browserWithoutCors'
  }
  return 'proxy'
}